import type { CryptoAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { calculateCryptoBalance } from "./balance";

export const calculateCryptoPartInWallet = (
  userProduct: CryptoAsset,
  withCash: boolean,
  cashCurrency: Fiat,
  cryptoCurrency: Fiat
) => {
  const coins = userProduct?.cryptoData || [];
  const balance = calculateCryptoBalance(
    userProduct,
    withCash,
    cashCurrency,
    cryptoCurrency
  );

  return coins.map((coin) => {
    const amount = coin?.amount || 0;
    const rate = coin?.coinRate || 0;

    if (Number(balance) === 0) return 0;
    return (rate * amount) / balance;
  });
};
